export default "__VITE_ASSET__i$QAnqqG__"